define('models/cd_role',['require','backbone'],function(request){

    var Backbone = require("backbone");


    return Backbone.Model.extend({
        url : function (){
            // set the endpoint for restful api for country distributor roles
            return this.id ? (App.Config.apiBase + 'cd-roles/' + this.id + '/')
                            : (App.Config.apiBase + 'cd-roles/');
        },
        defaults : function () {
            return {
                id : null,
                role_name : "",
                distributors: 1,
                distributor_add: 1,
                distributor_update: 1,
                resellers : 1,
                reseller_add : 1,
                reseller_update : 1,
                customers : 1,
                customer_add : 1,
                customer_update : 1,
                customer_addNote : 1,
                customer_keyReset : 1,
                leads : 1,
                lead_add : 1,
                lead_update : 1,
                lead_addNote : 1,
                store : 1,
                store_addBasket : 1,
                orders : 1,
                licenses : 1,
                licenses_assign : 1,
                periodic_licenses : 1,
                periodic_licenses_extend : 1,
                payments : 1,
                settings : 1,
                distributor: null,
                wallets : 1,
                timeline : 1
            };
        }
    });
});
